import { trackEvent, trackPageview } from "@garantidos/utils/tracking"

const pageview = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/perguntas-qualificadoras",
    hashedCpf,
    implementationTeam: "cgi:v01"
  }

  const ga = {
    label: "IT:NL:NCC:CGI:Simulador:PerguntasQualificadoras",
    hashedCpf
  }

  trackPageview({ ga, ga4 })
}

const back = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/perguntas-qualificadoras",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "perguntas-qualificadoras-voltar",
    eventName: "click"
  }

  trackEvent({ ga4 })
}

const advance = () => {
  trackEvent({ segment: "Qualification Sent" })
}

const unqualified = (hashedCpf) => {
  const ga = {
    label: `BTN:CGI:EmprestimosConfiraAgora`,
    action: "CGI",
    hashedCpf
  }

  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/perguntas-qualificadoras",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "perguntas-qualificadoras-confira-agora",
    eventName: "click"
  }

  const segment = "crossell-shopping-qualification-cgi"

  trackEvent({ ga, ga4, segment })
}

const event = (labelTrackEvent, hashedCpf) => {
  const ga = {
    label: `BTN:Simulador:${labelTrackEvent}`,
    action: "Simulador",
    hashedCpf
  }

  trackEvent({ ga })
}

const status = (text, hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/perguntas-qualificadoras",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: `perguntas-qualificadoras-${
      text === "nao-tenho" ? `${text}-imovel` : text
    }`,
    eventName: "click"
  }

  trackEvent({ ga4 })
}

const ownership = (text, hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/perguntas-qualificadoras",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: `perguntas-qualificadoras-dono-${text}`,
    eventName: "click"
  }

  trackEvent({ ga4 })
}

const registration = (text, hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/perguntas-qualificadoras",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: `perguntas-qualificadoras-cartorio-${text}`,
    eventName: "click"
  }

  trackEvent({ ga4 })
}

const backHome = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/perguntas-qualificadoras",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "perguntas-qualificadoras-voltar-inicio",
    eventName: "click"
  }
  trackEvent({ ga4 })
}

const advanceGA4 = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/perguntas-qualificadoras",
    implementationTeam: "cgi:v01",
    hashedCpf,
    detail: "perguntas-qualificadoras-proximo",
    eventName: "click"
  }

  trackEvent({ ga4 })
}

const alert = (hashedCpf, error) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/perguntas-qualificadoras",
    hashedCpf,
    implementationTeam: "cgi:v01",
    eventName: "alert",
    description: "erro",
    detail: error.message
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replaceAll(/ /g, "-")
      .replaceAll(/!/g, "")
  }

  trackEvent({ ga4 })
}

export {
  pageview,
  back,
  unqualified,
  event,
  status,
  registration,
  ownership,
  advanceGA4,
  advance,
  alert,
  backHome
}
